import { useEffect, useRef, useState } from "react";

// Renders children only once the placeholder scrolls near the viewport,
// so below-the-fold sections (and their API calls) don't block first paint.
export default function LazyMount({ children, minHeight = 320, rootMargin = "400px", onVisible }) {
  const ref = useRef(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (show || !ref.current) return;
    if (!("IntersectionObserver" in window)) { setShow(true); return; }
    const io = new IntersectionObserver((entries) => {
      // Mount when near the viewport OR already scrolled past (e.g. jump-to-bottom).
      if (entries.some((e) => e.isIntersecting || e.boundingClientRect.top < window.innerHeight)) { setShow(true); onVisible?.(); io.disconnect(); }
    }, { rootMargin });
    io.observe(ref.current);
    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);
  return show ? children : <div ref={ref} style={{ minHeight }} aria-hidden="true" />;
}
